var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var FootprintLayers = require("./../../footprint/footprintLayers.js");

// TODO: this enum is copy pasted here :(
var MetalLayers = {
    TOP    : 0,
    BOTTOM : 1
};

var PcbTerminal = function () {
    lib_core.AbstractInstance.call(this);

    this.onInit("init", this.initialize);
    this.onAdd("onAdd", this.createGeometryShadows);
};
lib_core.inherit(PcbTerminal, lib_core.AbstractInstance);
lib_core.JsonParser.registerClass(PcbTerminal, "PcbTerminal");

module.exports = PcbTerminal;

PcbTerminal.prototype.createGeometryShadows = function(){
    var self = this;
    this.pos = this.shadow("pos",
        function(){
            var pos = self.description().getPos();
            if(!self.parent().onTopLayer()) {
                var flipLine = new lib_geometry.Line(new lib_geometry.Coord(0,1), new lib_geometry.Coord(0,0));
                pos = pos.flip(flipLine);
            }
            return pos.rotate(self.parent().angle()).add(self.parent().pos());
        },
        null,
        [this.parent().pos, this.parent().angle, this.parent().onTopLayer, this.description]
    );

    this.angle = this.shadow("angle",
        function(){
            return (self.description().angle() + self.parent().angle()) % 360;
        },
        null,
        [this.parent().angle, this.description]
    );

    this.segmentedGeometry = this.cachedFunction("segmentedGeometry",
        this._getSegmentedGeometry,
        [this.parent().pos, this.parent().angle, this.parent().onTopLayer, this.description]
    );

    this.bufferedSegmentedGeometry = this.cachedFunction("bufferedSegmentedGeometry",
        this._getBufferedSegmentedGeometry,
        [this.segmentedGeometry]
    );

    this.geometry = this.cachedFunction("geometry",
        this._getGeometry,
        [this.parent().pos, this.parent().angle, this.parent().onTopLayer, this.description]
    );

    this.segmentedHoleGeometry = this.cachedFunction("segmentedHoleGeometry",
        function(precision){
            // return the entire pad
            var basePoly = self.description().getDrillSegmentedGeometry(precision);
            var poly = basePoly.scale(self.parent().onTopLayer() ? 1 : -1, 1)
                .rotate(self.parent().angle())
                .translate(self.parent().pos());
            return poly;
        },
        [this.parent().pos, this.parent().angle, this.parent().onTopLayer, this.description]
    );

    this.boundingBox = this.cachedFunction("boundingBox",
        function () {
            return self.geometry().getBB();
        },
        [this.geometry]
    );

};

PcbTerminal.prototype.initialize = function () {
    var self = this;
    this.getLogicTerminal();
};

PcbTerminal.prototype.getLogicTerminal = function(){
    var self = this;
    if(!this.logicTerminal) {
        var packageInstance = this.parent().ancestor().parent();
        this.logicTerminal = packageInstance.terminalMap.get(this.template());
        packageInstance.terminalMap.onPut(this, function(key, element) {
            if(key === self.template())
                self.logicTerminal = element;
        });
    }
    return this.logicTerminal;
};


PcbTerminal.prototype.toString = function () {
    return "PcbTerminal("+this.pos().toString()+")";
};

PcbTerminal.prototype.logicNet = function() {
    // check if terminal is mapped
    if(!this.logicTerminal)
        return null;
    else
        return this.logicTerminal.net();
};

PcbTerminal.prototype.net = PcbTerminal.prototype.logicNet; //TODO: remove 'net' because confusing. in schematic net returns schematicnet, in pcb net returns logic neg

PcbTerminal.prototype._getGeometry = function() {
    var poly = this.description().geometry().toPolygon();
    poly = poly.scale(this.parent().onTopLayer() ? 1 : -1, 1);
    poly = poly.rotate(this.parent().angle());
    poly = poly.translate(this.parent().pos());
    return poly;
};
PcbTerminal.prototype._getSegmentedGeometry = function(precision, layerIndex, layerType) {
    var footprintLayerType, footprintLayerIndex;
    if(!layerType) footprintLayerType = "COPPER";
    if(layerIndex === undefined || layerIndex === null) {
        footprintLayerIndex = FootprintLayers.TOP;
    } else {
        switch(layerIndex) {
            case 0:
                footprintLayerIndex = this.parent().onTopLayer() ? FootprintLayers.TOP : FootprintLayers.BOTTOM;
                break;
            case 1:
                footprintLayerIndex = this.parent().onTopLayer() ? FootprintLayers.BOTTOM : FootprintLayers.TOP;
                break;
            default:
                footprintLayerIndex = FootprintLayers.INNER;
        }
    }
    var poly = this.description().segmentedGeometry(precision, footprintLayerIndex, footprintLayerType);
    if(poly) {
        poly = poly.scale(this.parent().onTopLayer() ? 1 : -1, 1)
                   .rotate(this.parent().angle())
                   .translate(this.parent().pos());
    }
    return poly;
};

PcbTerminal.prototype._getBufferedSegmentedGeometry = function(precision, layerIndex, layerType, bufferSize) {
    return this.segmentedGeometry(precision, layerIndex, layerType).buffer(bufferSize);
};

PcbTerminal.prototype.getLayers = function () {
    var layers = new lib_core.Collections.HashSet();
    for(var i=0; i<this.parent().parent().number_of_layers(); i++) {
        switch (i) {
            case 0:
                if(this.parent().onTopLayer()) {
                    if(this.description().getTopCopper()) layers.add(i);
                } else {
                    if(this.description().getBottomCopper()) layers.add(i);
                }
                break;
            case 1:
                if(this.parent().onTopLayer()) {
                    if(this.description().getBottomCopper()) layers.add(i);
                } else {
                    if(this.description().getTopCopper()) layers.add(i);
                }
                break;
            default:
                if(this.description().getInnerCopper()) layers.add(i);
                break;
        }
    }
    return layers;
};

PcbTerminal.prototype.getConnectedSegments = function () {
    return this.parent().parent().vtxConSegMap.get(this) || new lib_core.Collections.HashSet();
};

PcbTerminal.prototype.getCopper = function (layerIndex) {
    var shape;
    switch (layerIndex) {
        case 0:
            if(this.parent().onTopLayer())
                return this.description().getTopCopper();
            else
                return this.description().getBottomCopper();
            break;
        case 1:
            if(this.parent().onTopLayer())
                return this.description().getBottomCopper();
            else
                return this.description().getTopCopper();
            break;
        default:
            return this.description().getInnerCopper();
    }
};

PcbTerminal.prototype.getTopSolderMask = function () {
    if(this.parent().onTopLayer())
        return this.description().getTopSolderMask();
    else
        return this.description().getBottomSolderMask();
};

PcbTerminal.prototype.getBottomSolderMask = function () {
    if(this.parent().onTopLayer())
        return this.description().getBottomSolderMask();
    else
        return this.description().getTopSolderMask();
};

PcbTerminal.prototype.getTopSolderPaste = function () {
    if(this.parent().onTopLayer())
        return this.description().getTopSolderPaste();
    else
        return this.description().getBottomSolderPaste();
};

PcbTerminal.prototype.getBottomSolderPaste = function () {
    if(this.parent().onTopLayer())
        return this.description().getBottomSolderPaste();
    else
        return this.description().getTopSolderPaste();
};

PcbTerminal.prototype.getHole = function () {
    return this.description().getHole();
};

PcbTerminal.prototype.getThermalCutout = function () {
    var poly = this.description().getThermalCutout.apply(this, arguments);
    if(poly) {
        poly = poly.rotate(this.parent().angle())
                   .translate(this.parent().pos());
    }
    return poly;
};
